import React from 'react';

const isChunkLoadError = (error) => {
  const message = String(error?.message || '');
  const name = String(error?.name || '');
  return name.includes('ChunkLoadError') || message.includes('Loading chunk');
};

class LazyChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const chunkError = isChunkLoadError(error);
    const title = chunkError ? 'Application update detected' : 'Something went wrong';
    const message = chunkError
      ? 'A new version was loaded and one page chunk is outdated. Reload to continue.'
      : 'Unexpected error occurred while loading this page.';

    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
        <div className="w-full max-w-md rounded-2xl border border-cream/60 bg-white p-6 shadow-sm">
          <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
          <p className="mt-2 text-sm text-slate-600">{message}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-5 inline-flex rounded-lg bg-primary-dark px-4 py-2 text-sm font-medium text-white hover:bg-primary-dark/90"
          >
            Reload app
          </button>
        </div>
      </div>
    );
  }
}

export default LazyChunkErrorBoundary;

